import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_LAND_USE_OVERVIEW',
  name: 'Workspace Project Land Use Overview',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'description', title: 'Description' },
    { key: 'totalSize', title: 'Total Size' },
    { key: 'carbonCreditsTotalSize', title: 'Carbon credits total size' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPLOAD', 'DESTROY'],
}

export default scope
